
import { Component, Prop, Vue } from 'vue-property-decorator'
import  {login} from "@/apis/login/login";
import studentInfo from "@/views/Member/studentInfo/studentInfo.vue";
import {Toast} from "vant";
import i18n from '@/lang';

@Component
export default class BindWechat extends Vue {
  private mobilePhoneOrEmail = '';
  private countErrorMsg = '';
  private password = ''

  login() {
    this.checkMobilePhoneOrEmail()
    if (this.countErrorMsg) {
      Toast(i18n.t('Account.请检查登录信息'));
    } else {
      if (!window.localStorage.getItem('code_key') || window.localStorage.getItem('code_key') === 'undefined') {
        Toast(i18n.t('Account.没有读取到code_key'));
        return;
      }
      login(this.mobilePhoneOrEmail, this.password).then(res => {
        window.localStorage.setItem('token', res.token);
        window.dispatchEvent(new CustomEvent('onLoginSucceed'));
        this.$store
          .dispatch('setUserInfo')
          .then(() => {
            this.$router.push('/');
          })
          .catch((e) => {
            Toast(i18n.t('Account.登录失败'));
          })
      }).catch(e => {
        console.log(e);
        Toast(e.message || i18n.t('Account.登录失败'))
      })
    }
  }
  checkMobilePhoneOrEmail() {
    if(this.mobilePhoneOrEmail && this.mobilePhoneOrEmail.length>0){
      let isMobilePhone = /^1\d{10}$/.test(this.mobilePhoneOrEmail);
      let isEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.mobilePhoneOrEmail);
      this.makeCountErrorMsg("mobilePhoneOrEmail", isMobilePhone || isEmail);
    }
  }

  goRegister() {
    this.$router.push('register')
  }

  makeCountErrorMsg(type: 'pwd' | 'pwdRepeat' | 'mobilePhoneOrEmail', res: boolean) {
    this.countErrorMsg = '';
    if (!res) {
      switch (type) {
        case 'pwd':
          this.countErrorMsg = i18n.t('Account.请检查密码格式应大于6位') as string;
          break;
        case "pwdRepeat":
          this.countErrorMsg = i18n.t('Account.两次密码应该相同') as string;
          break
        case "mobilePhoneOrEmail":
          this.countErrorMsg = i18n.t('Account.请检查账号格式') as string;
          break;
        default:
          return;
      }
    }
  }
  mounted() {
    Toast.clear();
    this.$setNavInfo({
      title: i18n.t('Account.绑定账号') as string
    })
  }
}
